module.exports = __webpack_public_path__ + "img/5-1.bec06c3c.jpg";